<div class="card card-table-view card-table-view-tabs-with-pagination mb-2">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
          <tr>
            <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="machineName">
              <span translate>Name</span>
            </th>
            <th (sort)="onColumnSort($event)" class="d-none d-md-table-cell sortable" scope="col" sortable="machineLocation">
              <span translate>Location</span>
            </th>
            @if (filtering.F) {
              <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="numberOfEvents.errors">
                <span class="d-inline-flex d-md-none">
                  <span class="fa-solid fa-triangle-exclamation text-danger"></span>
                </span>
                <span class="d-none d-md-inline" translate>Errors</span>
              </th>
            }
            @if (filtering.W) {
              <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="numberOfEvents.warnings">
                <span class="d-inline-flex d-md-none">
                  <span class="fa-solid fa-circle-exclamation text-warning"></span>
                </span>
                <span class="d-none d-md-inline" translate>Warnings</span>
              </th>
            }
            @if (filtering.I) {
              <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="numberOfEvents.infos">
                <span class="d-inline-flex d-md-none">
                  <span class="fa-solid fa-circle-info text-info"></span>
                </span>
                <span class="d-none d-md-inline" translate>Infos</span>
              </th>
            }
            @if (filtering.D) {
              <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="numberOfEvents.debugs">
                <span class="d-inline-flex d-md-none">
                  <span class="fa-solid fa-gear text-debug"></span>
                </span>
                <span class="d-none d-md-inline" translate>Debugs</span>
              </th>
            }
            @if (filtering.IH) {
              <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="numberOfEvents.inhibits">
                <span class="d-inline-flex d-md-none">
                  <span class="fa-solid fa-ban text-muted"></span>
                </span>
                <span class="d-none d-md-inline" translate>Inhibits</span>
              </th>
            }
            <th class="td-expand"></th>
          </tr>
        </thead>
        <tbody>
          @for (item of statusEvents | paginate: paginateSettings; track item) {
            <scitis-status-event-group-row
              [menuItemParent]="menuItemParent"
              [filtering]="filtering"
              [eventDetails]="item"
              class="d-contents">
            </scitis-status-event-group-row>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>


